(() => {
 const setup=()=>{
  document.querySelectorAll('[data-ks-gear-addon]').forEach(row=>{
   if(row.dataset.ready)return;row.dataset.ready='true';
   row.querySelector('[data-ks-addon-variant]')?.addEventListener('change',event=>{const option=event.target.selectedOptions[0];row.querySelector('[data-ks-addon]').dataset.variantId=option.value;row.querySelector('[data-ks-addon-price]').textContent='+'+option.dataset.price;});
  });
  const head=document.querySelector('.ks-gear-head');if(!head)return;
  document.querySelectorAll('[data-ks-gear-buy],a[href="#chBuybox"],a[href="#db-buybox"],a[href="#ezn-buybox"],a[href="#ezbell-buy"],#ecla-close-cta').forEach(button=>{
   if(button.dataset.gearReady)return;button.dataset.gearReady='true';
   button.addEventListener('click',event=>{event.preventDefault();
    const product=head.querySelector('ks-product');
    const model=button.dataset.selectModel;
    if(model&&product?.data){
     const choices=head.querySelector('[data-ks-choice-data]');
     const variants=choices?JSON.parse(choices.textContent):[];
     const current=variants.find(v=>String(v.id)===product.input.value);
     const matches=variants.filter(v=>v.options.includes(model));
     const selected=matches.find(v=>current&&v.options.every((value,i)=>value===model||value===current.options[i]))||matches.find(v=>v.available)||matches[0];
     if(selected)product.selectVariant(selected.id,true);
    }
    head.querySelector('.ks-pdp-purchase').scrollIntoView({behavior:'smooth',block:'center'});head.querySelector('[data-ks-add]').focus({preventScroll:true});});
  });
  const program=document.querySelector('.ch-program');const link=document.querySelector('[data-ks-program-link]');if(program&&link){if(!program.id)program.id='KsGearProgram';link.href='#'+program.id;}
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();document.addEventListener('shopify:section:load',setup);
})();
